
import { PulseBaseProvider } from '../../base-classes';

const adTargetingParametersUri = '/api/ads/targeting/v1/parameters';
const adTargetingParametersCacheKey = 'wbAdTargetingParametersCacheKey';

export class AdTargetingParameterProvider extends PulseBaseProvider {
    constructor(baseUrl, authId, secret, options, logger) {
        super(baseUrl, authId, secret, options, logger);

        this.storage.sync[adTargetingParametersCacheKey] = this.adTargetingParametersSyncer.bind(this);
    }

    async adTargetingParametersSyncer(params) {
        const { id, syncParams, resolve, reject } = params;

        let queryParams = {
            ...syncParams.stdParameters
            ,locationType: 'latitudelongitude'
            ,location: `${syncParams.latitude},${syncParams.longitude}`
            ,stationId: syncParams.stationId
            ,providerId: syncParams.providerId
            ,adServer: syncParams.adServer
            ,units: syncParams.units
            ,verbose: syncParams.verbose
        };

        return await super.syncData(syncParams.key, id, queryParams, adTargetingParametersUri, resolve, reject, null, syncParams.pulseApi);

    }

    async getAdTargetingParameters(latitude, longitude, stationId, providerId, adServer, units, stdParameters, refresh = false, verbose = false) {

        const syncParams = {
            latitude
            ,longitude
            ,stationId
            ,providerId
            ,adServer
            ,units
            ,refresh
            ,verbose
        };

        const id = JSON.stringify(syncParams);

        syncParams.stdParameters = stdParameters;

        if (refresh) {
            super.removeFromStorage(adTargetingParametersCacheKey, id);
        }

        return await super.loadFromStorage(adTargetingParametersCacheKey, id, syncParams);
    }

}
